import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable,Subject,of} from 'rxjs';
import { APIConstants } from 'src/app/app.constants';
import { map, shareReplay } from 'rxjs/operators';
import { OrderedProductDto } from 'src/app/models/OrderDto';

@Injectable({
    providedIn:'root'
})

export class ProductService{
    private _allProducts:Subject<any> = new Subject();
    private _productDetail:Subject<any> = new Subject();
    private _variants:Subject<any> = new Subject();
    public readonly productDetail$:Observable<any> = this._productDetail.asObservable();
    public readonly allProducts$:Observable<any> = this._allProducts.asObservable();
    public readonly variants$:Observable<any> = this._variants.asObservable();
    constructor(private http:HttpClient){
    }
    getProducts():Observable<any>{
        return this.http.get<any>(APIConstants.BASE_URL+"/products/all");
    }

    getProduct(query):Observable<any>{
        return this.http.get<any>(APIConstants.BASE_URL+"/products"+query);
    }
    getProducts2(){
        return this.http.get("assets/products.json");
    }

    productFetched(product:any) {
        this._productDetail.next(product)
    }

    variantsFetched(variants){
        this._variants.next(variants);
    }

    allProductsFetched(products:any){
        this._allProducts.next(products);
    }
}
